import { useTranslation } from 'react-i18next';

import { TOptions } from 'i18next';

const defaultOptions = {
  APP: import.meta.env.VITE_APP_NAME,
};

export function useTrans(
  ns?: Parameters<typeof useTranslation>[0],
  options?: Parameters<typeof useTranslation>[1],
) {
  const { t, ...rest } = useTranslation(ns, options);
  const myT = (key: Parameters<typeof t>[0], userOptions?: Parameters<typeof t>[1]) => {
    // 合并默认options和用户提供的options
    const finalOptions = { ...defaultOptions, ...(userOptions as TOptions) };
    return t(key, finalOptions);
  };
  return { ...rest, t: myT };
}
